"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var _Partner = require("../../contexts/Partner");
var _Logo = _interopRequireDefault(require("./Logo"));
var _Spacer = _interopRequireDefault(require("../common/Spacer"));
var _Container = _interopRequireDefault(require("../Container"));
var _excluded = ["image", "webView"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var wlHeader = 'https://cdn.yc.level.travel/email/2020/wl-header-background.png';
var Header = function Header(_ref) {
  var image = _ref.image,
    webView = _ref.webView,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useContext = (0, _react.useContext)(_Partner.PartnerContext),
    isWl = _useContext.isWl;
  var styles = {
    container: {
      textAlign: 'center'
    },
    wlContainer: {
      backgroundImage: "url(".concat(wlHeader, ")"),
      height: '92px',
      backgroundPosition: 'center',
      backgroundSize: 'contain'
    },
    tagline: {
      fontSize: '12px',
      color: isWl ? _userflow["default"].colors.white : _userflow["default"].colors.greyLight
    },
    image: {
      maxWidth: '580px',
      width: '100%',
      height: '150px',
      backgroundImage: "url(".concat(image, ")"),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderRadius: "".concat(_userflow["default"].shape.borderRadiusBig, " ").concat(_userflow["default"].shape.borderRadiusBig, " 0 0")
    }
  };
  var containerStyles = _objectSpread(_objectSpread({}, styles.container), isWl ? styles.wlContainer : {});
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], (0, _extends2["default"])({
    style: containerStyles
  }, props, {
    className: "header"
  }), !webView && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: isWl ? 14 : 24
  }), /*#__PURE__*/_react["default"].createElement(_Logo["default"], null), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 5
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.tagline
  }, "\u041F\u043E\u0438\u0441\u043A, \u0432\u044B\u0431\u043E\u0440 \u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0430 \u0442\u0443\u0440\u043E\u0432 \u043E\u043D\u043B\u0430\u0439\u043D")), image && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !webView && /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 18
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.image
  })));
};
Header.defaultProps = {
  image: null
};
Header.propTypes = {
  image: _propTypes["default"].string
};
var _default = exports["default"] = Header;